export default __webpack_public_path__ + "static/media/warehouse.4d0bf00b.svg";